/* eslint-disable react/require-default-props */
import React, { useMemo } from 'react'
import { InfoIconOutline } from '@usap/uicomponents'
import {
  Wrapper,
  Container,
  Info,
  Message,
} from './CorePriceBadge.css'

interface CorePriceBadgeProps {
  onClick: () => {};
  corePrice: number;
  showCorePrice: boolean;
  forCart?: boolean;
  forCheckout?: boolean;
  forAccount?: boolean;
  forPlp?: boolean;
  uniqueId?: number | undefined;
}

export function CorePriceBadge(props: CorePriceBadgeProps) {
  const {
    corePrice = 0,
    onClick,
    showCorePrice,
    uniqueId,
    forCart,
    forCheckout,
    forAccount,
    forPlp,
  } = props

  const corePriceMessage = useMemo(
    () => (forCart || forCheckout || forAccount ? 'What\'s this?' : `+ $${corePrice.toFixed(2)} Refundable Core Charge`),
    [corePrice, forCart, forCheckout, forAccount],
  )

  return (
    <Wrapper
      forCart={forCart}
      forCheckout={forCheckout}
      forAccount={forAccount}
      forPlp={forPlp}
    >
      <Container
        id={`iconClick${typeof uniqueId === 'undefined' ? '' : uniqueId}`}
        onClick={onClick}
        role="button"
        tabIndex={0}
        aria-label="core charge"
      >
        <Message
          showPointer={showCorePrice}
          data-testid="pdp-core-charge-text"
          forCart={forCart}
          forCheckout={forCheckout}
          forAccount={forAccount}
          forPlp={forPlp}
        >
          {corePriceMessage}
          <span className="info">
            {(!forCart && !forCheckout && !forAccount) && (
              <Info
                size="13px"
                icon={InfoIconOutline}
                color="#333"
                viewBox="0 0 20 20"
              />
            )}
          </span>
        </Message>
      </Container>
    </Wrapper>
  )
}

export default CorePriceBadge
